import EditablePeopleField from './EditablePeopleField'
import React from 'react';
const PeopleListItem = ({group,index,saveGroup,deletePerson})=>{
   

 
    return (
        <>
           <EditablePeopleField index={index} group={group} saveGroup={saveGroup} deletePerson={deletePerson}/>  
        </>

    )
}


export default PeopleListItem;